import React from 'react';

import {
  AppointmentDetailDTO,
  AppointmentListDTO,
  BlockTypeEnum,
  TimezoneAbbreviationEnum
} from '_lib/api/apiTypes.shim';
import { Typography } from '_lib/components/Typography/Typography';
import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';

export interface AppointmentWindowDisplayProps {
  appointment: AppointmentDetailDTO | AppointmentListDTO;
  timezone: TimezoneAbbreviationEnum;
}

export const AppointmentWindowDisplay = (props: AppointmentWindowDisplayProps): React.ReactElement => {
  const { appointment, timezone } = props;

  const appointmentWindowStartTime = appointment.appointmentWindow.startTime;
  const appointmentWindowEndTime = appointment.appointmentWindow.endTime;

  return (
    <Typography>
      {`${DateUtils.format(appointment.date, DateFormatEnum.DateLongWeekday, { timezone })} `}
      {appointment.appointmentWindow.blockType === BlockTypeEnum.ALL_DAY && <span>- ALL DAY</span>}
      {appointment.appointmentWindow.blockType === BlockTypeEnum.RANGE && (
        <span>
          @
          {` ${DateUtils.format(appointmentWindowStartTime, DateFormatEnum.Time, { timezone })} - ${DateUtils.format(
            appointmentWindowEndTime,
            DateFormatEnum.Time,
            { timezone }
          )} (${timezone})`}
        </span>
      )}
      {appointment.appointmentWindow.blockType === BlockTypeEnum.SPECIFIC_TIME && (
        <span>
          @{` ${DateUtils.format(appointmentWindowStartTime, DateFormatEnum.Time, { timezone, showTimezone: true })}`}
        </span>
      )}
    </Typography>
  );
};
